var prefix = function prefix(key) {
  return '@atlaskit-private-do-not-use/dropdown-menu:' + key;
};

export var focusManagerContext = prefix('focus-manager');
export var selectionCacheContext = prefix('selection-cache');
export var selectionManagerContext = prefix('selection-manager');
export var clickManagerContext = prefix('click-manager');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/item/dist/esm/util/contextNamespace.js
// module id = 178
// module chunks = 0